<template>
  <div class="calculations">
    <div class="calculations__panel">
      <router-view />
    </div>
    <div class="calculations__map">
      <c-map />
      <c-timeline v-if="routeName === 'c-scenario' && times.length" />
    </div>
  </div>
</template>

<script>
import CMap from "@/components/calculations/map/c-map";
import CTimeline from "@/components/calculations/timeline/timeline";

export default {
  components: {
    CMap,
    CTimeline
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    times() {
      return this.$store.state.calculations.times;
    }
  }
};
</script>

<style lang="scss">
.calculations {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  background-color: var(--bg_surface) !important;

  &__panel {
    height: 100%;
    min-width: 260px;
    box-shadow: 2px 0 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    background-color: var(--bg_panel_primary) !important;
  }

  &__map {
    flex: 1;
    height: 100%;
    position: relative;
  }
}
</style>
